"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CornerUpRight = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "corner-up-right" },
            react_1.default.createElement("path", { id: "Icon", d: "M3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20H3ZM20 9L20.7071 9.70711C21.0976 9.31658 21.0976 8.68342 20.7071 8.29289L20 9ZM4.65396 12.2761L5.54497 12.73L4.65396 12.2761ZM7.27606 9.65396L7.73005 10.545L7.27606 9.65396ZM14.2929 13.2929C13.9024 13.6834 13.9024 14.3166 14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071L14.2929 13.2929ZM15.7071 3.29289C15.3166 2.90237 14.6834 2.90237 14.2929 3.29289C13.9024 3.68342 13.9024 4.31658 14.2929 4.70711L15.7071 3.29289ZM5 20V18.6H3V20H5ZM13.6 10H20V8H13.6V10ZM5 18.6C5 16.9033 5.00078 15.691 5.07842 14.7406C5.15512 13.802 5.30179 13.2073 5.54497 12.73L3.76295 11.8221C3.35217 12.6283 3.17186 13.5154 3.08507 14.5778C2.99922 15.6285 3 16.9363 3 18.6H5ZM13.6 8C11.9363 8 10.6285 7.99922 9.57778 8.08507C8.51543 8.17186 7.62827 8.35217 6.82207 8.76295L7.73005 10.545C8.20731 10.3018 8.80197 10.1551 9.74064 10.0784C10.691 10.0008 11.9033 10 13.6 10V8ZM5.54497 12.73C6.02433 11.7892 6.78924 11.0243 7.73005 10.545L6.82207 8.76295C5.50493 9.43407 4.43407 10.5049 3.76295 11.8221L5.54497 12.73ZM15.7071 14.7071L20.7071 9.70711L19.2929 8.29289L14.2929 13.2929L15.7071 14.7071ZM20.7071 8.29289L15.7071 3.29289L14.2929 4.70711L19.2929 9.70711L20.7071 8.29289Z" }))));
};
exports.default = CornerUpRight;
